module.exports = ".reservation-list li {\n  list-style-type: none;\n  margin-left: 20px;\n  padding: 10px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/sidebar/sidebar.component.scss
// module id = ./src/app/core/sidebar/sidebar.component.scss
// module chunks = main